export const thenFunction = () => {
  if (typeof window !== 'undefined') {
    window?.location?.reload();
  }
  return { default: () => null };
};
